import API_ENDPOINT from "../constants/api_endpoint.constant";
import axios from '../utils/axiosService';

export default class SignupService {
    signup(info) {
        return axios.post(API_ENDPOINT.SIGNUP, {
            info
        });
    }
}